import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
// import { thunk } from "redux-thunk";
import authReducer from "./AuthSlice";
import sellerSlice from "./seller/SellerSlice";
import sellerProductReducer from "./seller/sellerProductSlice";
import productSlice from "./customer/productSlice";
import authSlice from "./AuthSlice";
import cartSlice from "./customer/cartSlice";
import orderSlice from "./customer/orderSlice";
import wishlistSlice from "./customer/wishlistSlice";
import homeSlice from "./customer/customerSlice";
import addressReducer from "./customer/addressSlice";

import sellerOrderSlice from "./seller/sellerOrderSlice";
import transactionSlice from "./seller/transactionSlice";

import homeCategorySlice from "./admin/adminSlice";
import dealSlice from "./admin/DealSlice";
import categoryReducer from "./customer/categorySlice";

const rootReduer = combineReducers({
  //auth: authReducer, // 2. Add it here!
  seller:sellerSlice,
  sellerProduct:sellerProductReducer,
  product:productSlice,
  auth:authSlice,
  cart: cartSlice,
  order: orderSlice,
  wishlist: wishlistSlice,
  customer: homeSlice,
  address: addressReducer,
  category: categoryReducer,
  
  sellerOrder: sellerOrderSlice,
  transactions: transactionSlice,

  homeCategory: homeCategorySlice,
  deal: dealSlice,
});

const store = configureStore({
  reducer: rootReduer,
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReduer>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;